import React from 'react';
import PropTypes from 'prop-types';
import {
  feesCard,
  feesSideSection
} from '../componentSections/detailsFeesComponents';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';

const DetailsFees = ({
  componentContent = {},
  fptiImpression,
  handleClickFPTI
}) => {
  const { subtitleLink, subtitle, title, fees } = componentContent;

  if (!fees) {
    fireDetailsPageComponentFailureFpti({
      data: { fees },
      componentName: 'DetailsFees',
      fptiImpression
    });
    return null;
  }

  let parsedFees = parseData(fees);

  return (
    <section id="details-fees">
      <div className="details-fees-container">
        {feesCard(parsedFees, handleClickFPTI)}
        {title &&
          feesSideSection({
            subtitleLink,
            subtitle,
            title,
            handleClickFPTI
          })}
      </div>
    </section>
  );
};

DetailsFees.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  cardFooterText: PropTypes.string,
  feeSideLinkText: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideTitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  feeSubtext: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  fee: PropTypes.string,
  featureItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  feeSideFPTI: PropTypes.string
};

export default DetailsFees;
